import coinStack from "@/assets/objects/coin-stack.webp";
import crown from "@/assets/objects/crown.webp";
import medalActivated from "@/assets/objects/medal-activated.webp";
import padlock from "@/assets/objects/padlock.webp";
import restHourglass from "@/assets/objects/rest-hourglass.webp";
import sparkles from "@/assets/objects/sparkles.webp";
import stopwatch from "@/assets/objects/stopwatch.webp";
import whistle from "@/assets/objects/whistle.webp";

/**
 * The promotional badge a coach picked in the product form.
 *
 * A preset is stored as `preset:<key>` so the checkout reads it in the buyer's own language and
 * draws the object the coach saw, while a badge the coach typed himself is kept and shown as he
 * wrote it. Objects are the round-4 set, the same eight the product form offers.
 */

const PRESET_PREFIX = "preset:";

const PRESET_OBJECTS: Record<string, string> = {
  popular: crown,
  best_value: coinStack,
  new: sparkles,
  limited: restHourglass,
  bestseller: medalActivated,
  coach_pick: whistle,
  selling_fast: stopwatch,
  exclusive: padlock,
};

export interface PromotionalBadgePreset {
  key: string;
  object: string;
}

export function promotionalBadgePreset(
  value?: string | null,
): PromotionalBadgePreset | undefined {
  if (!value || !value.startsWith(PRESET_PREFIX)) return undefined;
  const key = value.slice(PRESET_PREFIX.length);
  const object = PRESET_OBJECTS[key];
  return object ? { key, object } : undefined;
}
